(() => {
  const selectors = {
    section: '[data-collection-tabs]',
    tab: '[role="tab"]',
    panel: '[role="tabpanel"]'
  };

  const transitionDuration = 220;
  const panelTimers = new WeakMap();

  const clearPanelTimer = (panel) => {
    const timer = panelTimers.get(panel);

    if (timer) {
      window.clearTimeout(timer);
      panelTimers.delete(panel);
    }
  };

  const refreshNativeSliders = () => {
    window.dispatchEvent(new Event('resize'));
  };

  const showPanel = (panel) => {
    clearPanelTimer(panel);
    panel.hidden = false;
    panel.classList.remove('is-leaving');
    panel.classList.add('is-entering');

    requestAnimationFrame(() => {
      panel.classList.add('is-active');
      refreshNativeSliders();
    });

    const timer = window.setTimeout(() => {
      panel.classList.remove('is-entering');
      panelTimers.delete(panel);
    }, transitionDuration);

    panelTimers.set(panel, timer);
  };

  const hidePanel = (panel) => {
    clearPanelTimer(panel);
    panel.classList.remove('is-active');
    panel.classList.remove('is-entering');
    panel.classList.add('is-leaving');

    const timer = window.setTimeout(() => {
      panel.hidden = true;
      panel.classList.remove('is-leaving');
      panelTimers.delete(panel);
    }, transitionDuration);

    panelTimers.set(panel, timer);
  };

  const activateTab = (tabs, panels, tab, shouldFocus = true) => {
    if (tab.getAttribute('aria-selected') === 'true') return;

    const targetPanelId = tab.getAttribute('aria-controls');

    tabs.forEach((currentTab) => {
      const isActive = currentTab === tab;
      currentTab.classList.toggle('is-active', isActive);
      currentTab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      currentTab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      if (panel.id === targetPanelId) {
        showPanel(panel);
      } else if (!panel.hidden) {
        hidePanel(panel);
      }
    });

    if (shouldFocus) {
      tab.focus({ preventScroll: true });
    }
  };

  const getNextIndex = (tabs, currentIndex, key) => {
    if (key === 'Home') return 0;
    if (key === 'End') return tabs.length - 1;
    if (key === 'ArrowLeft') return currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
    if (key === 'ArrowRight') return currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
    return currentIndex;
  };

  const initCollectionTabs = (section) => {
    if (section.dataset.collectionTabsReady === 'true') return;

    const tabs = Array.from(section.querySelectorAll(selectors.tab));
    const panels = Array.from(section.querySelectorAll(selectors.panel));

    if (!tabs.length || !panels.length) return;

    section.dataset.collectionTabsReady = 'true';

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tabs, panels, tab, false));

      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        const nextIndex = getNextIndex(tabs, index, event.key);
        activateTab(tabs, panels, tabs[nextIndex]);
      });
    });
  };

  const initAllCollectionTabs = (root = document) => {
    root.querySelectorAll(selectors.section).forEach(initCollectionTabs);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllCollectionTabs());
  } else {
    initAllCollectionTabs();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllCollectionTabs(event.target);
  });
})();
/* ==========================
   Collection Page Navigation
========================== */

document.addEventListener('DOMContentLoaded', () => {
  const activeTab = document.querySelector('.collection-tab.is-active');

  if (activeTab) {
    activeTab.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
  }
});